module.exports = __webpack_public_path__ + "Images/dark-red-circle.png";


//////////////////
// WEBPACK FOOTER
// ./Images/timeline_js/images/dark-red-circle.png
// module id = 1861
// module chunks = 2